import { useMemo } from 'react'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { useQueryRequest } from '../core/QueryRequestProvider'
import { useListView } from '../core/ListViewProvider'
import { useListFilters } from '../core/ListFiltersProvider'
import { AtendimentoList } from '../../../atendimento/core/_models'
import { CustomTable, TableEmptyState } from '../../../../../components'
import { IconPaths } from '../../../../../../_metronic/helpers'
import { GenerateAsoColumns } from './columns/_columns'
import { useT } from '_metronic/i18n/Metronici18n'

export const GenerateAsoTable = () => {
  const { isLoading, isError, refetch, response } = useQueryResponse()
  const { selected } = useListView()
  const { hasFilters, clearFilters } = useListFilters()
  const { t } = useT()

  const columns = useMemo(() => GenerateAsoColumns(t), [t])

  const emptyState = hasFilters ? (
    <TableEmptyState
      title='Nenhum ASO encontrado'
      description='Revise o paciente, o protocolo, a situação ou o estado selecionado.'
      action={{ label: 'Limpar filtros', onClick: clearFilters }}
    />
  ) : (
    <TableEmptyState
      icon={IconPaths.Check}
      title='Nenhum ASO pendente de geração'
      description='Os atendimentos ASO sob sua responsabilidade aparecem aqui quando estiverem prontos para gerar.'
    />
  )

  return (
    <CustomTable<AtendimentoList>
      id='kt_table_generate_aso'
      ariaLabel='ASOs para gerar'
      itemLabel={{ singular: 'ASO', plural: 'ASOs' }}
      data={response?.data || []}
      columns={columns}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
      emptyState={emptyState}
      isRowSelected={(row) => selected.includes(row.id)}
      queryHooks={{ useQueryRequest, useQueryResponse }}
    />
  )
}
